<!-- 活动列表 -->
<template>
  <div>
    <div
      class="active-item"
      v-for="(item, index) in list"
      :key="index"
      @click="navDetails(item.train_activity_id)"
    >
      <img :src="type==0?item.activity_image:item.image" class="active-img" />
      <div class="active-name">
        <div class="active-top">
          <P>{{type==0?item.activity_name:item.name}}</P>
          <div class="active-mode">
            <span>免费</span>
            <span>{{item.apply_number}}人参与</span>
          </div>
        </div>
        <div class="active-btn">
          <button
            :class="{'end':item.status==3}"
          >{{item.status=='1'?'参与':item.status==2?'进行中':'已结束'}}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props:['list','type'],
  data() {
    return {};
  },
  computed: {},
  methods: {
    navDetails(id) {
      var type=this.type;
      this.$router.push({
        name: "ActiveDetails",
        query: {
          id: id,
          type:type
        }
      });
    }
  },
  created() {},
  mounted() {}
};
</script>
<style lang='less' scoped>
.active-item {
  background: #fff;
  border-radius: 0.16rem;
  margin-bottom: 0.2rem;
  .active-img {
    width: 100%;
    height: 4rem;
    border-radius: 0.16rem;
  }
  .active-name {
    font-size: 0.3rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0.2rem 0.1rem;
    .active-top {
      max-width: 75%;
      p {
        font-weight: bold;
        line-height: 0.24rem;
        color: rgba(51, 51, 51, 1);
        font-weight: bold;
        line-height: 0.3rem;
        color: rgba(51, 51, 51, 1);
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
      }
      .active-mode {
        margin-top: 0.1rem;
        span {
          color: #ff4343;
          font-size: 0.24rem;
        }
        span:last-child {
          margin-left: 0.2rem;
          font-weight: 400;
          line-height: 0.24rem;
          color: rgba(128, 128, 128, 1);
        }
      }
    }
    .active-btn {
      button {
        padding: 0.1rem 0.3rem;
        border-radius: 0.06rem;
        background: #ff4343;
        font-size: 0.24rem;

        font-weight: 400;
        line-height: 0.33rem;
        color: rgba(255, 255, 255, 1);
      }
      .end {
        background: #ccc;
      }
    }
  }
}
</style>